import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import parseHTML from 'html-react-parser';

const SearchHit = (props) => {
    const {
        hit: {
            url, title, introduction,
        },
    } = props;
    return (
        <div className="search-hit">
            <Link to={`/${url}`} className="search-title">{title}</Link><br />
            {introduction &&
                <div className="introduction">{parseHTML(introduction)}</div>
            }
        </div>
    );
};

export default SearchHit;

SearchHit.propTypes = {
    hit: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
        introduction: PropTypes.string,
    })
};
